import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Common_Shimmer from "../Markets/Equity/Equityshimmer/common_shimmer";
import "@frameworks/web/stylesheets/components/features/LeadGeneration/LeadGenerationMain.scss";
const LeadGeneration = lazy(() => import("./LeadGeneratnMain"));
const LeadGenRouting = () => {
    return (React.createElement("div", null,
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/lead-generation", element: React.createElement(Suspense, { fallback: React.createElement(Common_Shimmer, null) },
                    React.createElement(LeadGeneration, null)) }))));
};
export default LeadGenRouting;
